
<div
    class  = "lm-border doc-entry mb-0 mr-1"
    style="position: relative"
    :class="border + ' ' + background(hover)"
    @click = "onDocument"
>
    <p-dms-properties
        v-model       = "showProperties"
        :step-data-id = "stepDataId"
        :category     = "category"
        :document     = document
    />

    <p-dms-information
        v-model       = "showInformation"
        :information  = information
    />

    <p-dms-versions
        v-model       = "showVersions"
        :step-data-id = "stepDataId"
        :document     = document
    />

    <p-dms-combine
        v-model       = "showCombine"
        :step-data-id = "stepDataId"
    />

    <p-dms-move
        v-model       = "showMove"
        :step-data-id = "stepDataId"
        :document     = "document"
    />

    <d-dms-stamper
        v-if     = "showStamper"
        ref      = "stamper"
        :stamp   = "stampCategory"
        @stamped = "onStamped"
        @closed  = "onStamperClosed"
    />


    <div style="display: block; " class="pl-2 doc-col" >
        <div class="doc-info v-flex">
            <c-inc-document-icon
                class="pr-0"
                style="margin-top: -5px; max-height: 20px; margin-right: 2px;"
                :document = "document"
                :size = "22"
                :color="hover ? 'white primary--text' : 'primary white--text'"
            />

            <!-- unit chip -->
            <div v-if="document.unitName" class="doc-unit mr-1" :class="hover ? 'white primary--text' : 'primary white--text'">
                {{ document.unitName }}
            </div>
            <!-- unit chip -->

            <!-- bid chip -->
            <div v-if="document.bidId && !compact" class="doc-unit mr-1" :class="hover ? 'white--text' : 'primary--text'">
                {{ bidname }}
            </div>
            <!-- bid chip -->

            <!-- document type -->
            <div>
                {{ document.type ? document.type.name : '---'}}
            </div>
            <!-- document type -->


            <div
                v-if  = "allowQuickChange"
                class = "quick-change-toolbar v-flex"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                        <v-btn
                            v-bind      = "attrs"
                            v-on        = "on"
                            :color      = "hover ? 'white primary--text' : 'primary white--text'"
                            class       = "quick-change-button"
                            @click.stop = "onQuickChange(doctype.RG)"
                            elevation="0"
                            x-small
                        >
                            RG
                        </v-btn>
                    </template>
                    <span>Rechnung</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                        <v-btn
                            v-bind      = "attrs"
                            v-on        = "on"
                            :color      = "hover ? 'white primary--text' : 'primary lighten-2 white--text'"
                            class       = "quick-change-button"
                            @click.stop = "onQuickChange(doctype.MAH)"
                            elevation="0"
                            x-small
                        >
                            MAH
                        </v-btn>
                    </template>
                    <span>Rechnung</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                        <v-btn
                            v-bind      = "attrs"
                            v-on        = "on"
                            :color      = "hover ? 'white primary--text' : 'primary lighten-4 white--text'"
                            class       = "quick-change-button"
                            @click.stop = "onQuickChange(doctype.ST)"
                            elevation="0"
                            x-small
                        >
                            ST
                        </v-btn>
                    </template>
                    <span>Stornobeleg</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }" v-if = "isMaintenance">
                        <v-btn
                            v-bind      = "attrs"
                            v-on        = "on"
                            :color      = "hover ? 'white primary--text' : 'primary white--text'"
                            class       = "quick-change-button"
                            @click.stop = "onQuickChange(doctype.WB)"
                            elevation="0"
                            x-small
                        >
                            WB
                        </v-btn>
                    </template>
                    <span>Wartungsbericht</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }" v-if = "isAssessment">
                        <v-btn
                            v-bind      = "attrs"
                            v-on        = "on"
                            :color      = "hover ? 'white primary--text' : 'primary white--text'"
                            class       = "quick-change-button"
                            @click.stop = "onQuickChange(doctype.PB)"
                            elevation="0"
                            x-small
                        >
                            PB
                        </v-btn>
                    </template>
                    <span>Prüfbericht</span>
                </v-tooltip>

                <div v-if = "isRepair">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" >
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.AS)"
                                elevation="0"
                                x-small
                            >
                                AS
                            </v-btn>
                        </template>
                        <span>Arbeitsschein</span>
                    </v-tooltip>
                </div>

                <div v-if = "isRepair">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" >
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary  lighten-2  white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.ANG)"
                                elevation="0"
                                x-small
                            >
                                ANG
                            </v-btn>
                        </template>
                        <span>Angebot</span>
                    </v-tooltip>
                </div>

                <div v-if = "isRepair">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" >
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary lighten-4  white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.AUF)"
                                x-small
                                elevation="0"
                            >
                                AUF
                            </v-btn>
                        </template>
                        <span>Aufträge</span>
                    </v-tooltip>
                </div>

                <div>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isIncident">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.AS)"
                                x-small
                            >
                                AS
                            </v-btn>
                        </template>
                        <span>Arbeitsschein</span>
                    </v-tooltip>
                </div>
            </div>
            <v-spacer />
        </div>

        <div class="doc-subinfo" :class="compact ? 'doc-filename-compact' : 'doc-filename'">
            {{ document.name }}
        </div>
    </div>

    <v-spacer />

    <div style="display: block" class="doc-col">
        <div class="doc-date pr-2">
            {{ timeAsString(document.createdDate) }}
        </div>
        <div class="doc-subinfo">
            {{ document.createdBy }}
        </div>
    </div>

    <div style="padding-top: 12px;" >
        <input
            type         = "file"
            style        = "display:none"
            :accept      = "extensions"
            ref          = "uploadButton"
            @click.stop  = "onFileClick"
            @change      = "onReplaceFile"
        />
        <v-menu
            v-model = "menu"
            offset-x
        >
            <template v-slot:activator="{ props }">
                <a
                    @click.stop = "onMenu"
                    v-bind="props"
                    style="margin-top: -5px"
                >
                    <v-icon size="24" :color = "hover || menu ? 'white' : ''">mdi-dots-vertical</v-icon>
                </a>
            </template>

            <v-list style="width: 210px; font-size: 15px">
                <v-list-item @click="onShowDocument">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-eye"></i>
                        </div>
                        <div>{{ $t("dms.entry.menu.show") }}</div>
                    </div>
                </v-list-item>
                <v-list-item @click="onFadeInDocument">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon class="ml-n1" size="22" color="black">mdi-open-in-new</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.fadein") }}</div>
                    </div>
                </v-list-item>
                <v-list-item @click="onDownload">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-download menu-icon"></i>
                        </div>
                        <div>{{ $t("dms.entry.menu.download") }}</div>
                    </div>
                </v-list-item>

                <v-divider class="mt-2 mb-2" />

                <v-list-item @click="onInfo">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon class="ml-n1" size="22" color="black">mdi-information-outline</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.info") }}</div>
                    </div>
                </v-list-item>
                <v-list-item @click="onProperties">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-file-cog-outline</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.props") }}</div>
                    </div>
                </v-list-item>
                <v-list-item @click="onVersions" >
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-file-clock-outline</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.versions") }}</div>
                    </div>
                </v-list-item>
                <v-divider class="mt-2 mb-2" />
                <v-list-item
                    @click="onConfirmDetach"
                    v-if="(!document.stamped && document.messageId) && document.typename !== 'Mail - gesendet' && !document.referenced"
                >
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-unlink"></i>
                        </div>
                        <div>{{ $t("dms.entry.menu.detach") }}</div>
                    </div>
                </v-list-item>
                <v-list-item @click="onConfirmDelete" v-if="(!document.messageId || document.stamped)  && !document.referenced">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-trash-alt"></i>
                        </div>
                        <div>löschen</div>
                    </div>
                </v-list-item>

                <v-list-item @click="onReplace">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-file-replace-outline</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.replace") }}</div>
                    </div>
                </v-list-item>

                <v-list-item @click="onStamp">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-stamper</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.stamp") }}</div>
                    </div>
                </v-list-item>

                <v-list-item @click="onMove">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-file-move-outline</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.move") }}</div>
                    </div>
                </v-list-item>

                <v-divider class="mt-2 mb-2" />

                <v-list-item @click="onCombine">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <v-icon size="20" color="black">mdi-file-multiple</v-icon>
                        </div>
                        <div>{{ $t("dms.entry.menu.combine") }}</div>
                    </div>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</div>
